import React from 'react';
import ServicePageTemplate from '@/components/ServicePageTemplate';

const ReprogramacaoPage: React.FC = () => {
  return <ServicePageTemplate serviceSlug="servico-reprogramacao-ecu" />;
};

export default ReprogramacaoPage;
